/* eslint-disable no-alert */
import common from '../common';
import Scene from './Scene';
import IsoWorld from '../IsoWorld';
import i18next from 'i18next';

export default class EditorScene extends Scene {
	constructor() {
		super();

		this._world = null;
		this._editor = null;
		this._bindings = {};
		this._ground = 100;
		this._structure = 2;
		this._risk = 1;
		this._level = 0;
		this._tileset = '';
		this._structset = '';
		this._upgradeset = '';
		this._autoSaveFrame = 0;
		this._autoSaveRate = common.config.editor.autoSaveRate || 30;
		this._autoSaveHash = '';
		this._isLevelHidden = false;
		this._isStructuresHidden = false;
		this._isRiskHidden = false;

		this._riskColours = [
			0x9AD528, // Risk 1
			0xF7D503, // Risk 2
			0xFF8400, // Risk 3
			0xFF1900, // Risk 4
			0xBE22D4, // Risk 5
		];

		this.hitArea = new PIXI.Rectangle();
	}

	init() {
		super.init();

		this._world = new IsoWorld(44, 44);
		this._world.editorMode = true;
		this._world.signals.paint.add(this.onWorldTilePaint, this);
		this.addChild(this._world);
		common.world = this._world;

		this.loadEditor();

		this._editor = $('#editor');
		this._editor.html(_.template($('#template-default').html()));
		this._editor.show();

		$('input[name=world_column]').val(this._world.columns);
		$('output[name=world_column_output]').val(this._world.columns);

		$('input[name=world_row]').val(this._world.rows);
		$('output[name=world_row_output]').val(this._world.rows);

		this.populateSets();
		this.populateTiles();
		this.populateStructures();

		this._bindings.new = this._editor.on('click', '.new', (event) => {
			this.onNewButtonClick(event);
		});
		this._bindings.resize = this._editor.on('click', '.resize', (event) => {
			this.onResizeButtonClick(event);
		});
		this._bindings.fill = this._editor.on('click', '.fill', (event) => {
			this.onFillButtonClick(event);
		});
		this._bindings.flatten = this._editor.on('click', '.flatten', (event) => {
			this.onFlattenButtonClick(event);
		});
		this._bindings.shift = this._editor.on('click', '.shift', (event) => {
			this.onShiftButtonClick(event);
		});
		this._bindings.level = this._editor.on('change', 'input[name=tile_level]', (event) => {
			this.onInputTileLevelChange(event);
		});
		this._bindings.import = this._editor.on('click', '.import', (event) => {
			this.onImportButtonClick(event);
		});
		this._bindings.export = this._editor.on('click', '.export', (event) => {
			this.onExportButtonClick(event);
		});
		this._bindings.tileset = this._editor.on('change', 'select[name=select_tileset]', (event) => {
			this.onTilesetSelect(event);
		});
		this._bindings.structset = this._editor.on('change', 'select[name=select_structset]', (event) => {
			this.onStructsetSelect(event);
		});
		this._bindings.levelhide = this._editor.on('change', 'input[name=level_hide]', (event) => {
			this.onLevelHide(event);
		});
		this._bindings.riskhide = this._editor.on('change', 'input[name=risk_hide]', (event) => {
			this.onRiskHide(event);
		});
		this._bindings.structureshide = this._editor.on('change', 'input[name=structures_hide]', (event) => {
			this.onStructuresHide(event);
		});
		this._bindings.focus = this._editor.on('focus', '.focus', () => {
			P3.input.refocus = false;
		});
		this._bindings.blur = this._editor.on('blur', '.focus', () => {
			P3.input.refocus = true;
		});
	}

	destroy() {
		for (const i in this._bindings) {
			Object.hasOwn(this._bindings, i) && this._bindings[i].remove();
		}
		this._bindings = {};

		super.destroy();
	}

	resize() {
		super.resize();
		this._world.resize();

		this.hitArea.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
		this.hitArea.y = 0;
		this.hitArea.width = P3.View.width;
		this.hitArea.height = P3.View.height;
	}

	update() {
		super.update();
		this._world.update(window.dt);

		if (P3.input.isKeyDown(P3.keys.SPACE)) {
			this.placeStructure(this._world.currentTile, this._structure);
		}

		if (P3.input.isKeyDown(P3.keys.T)) {
			this.disableTile(this._world.currentTile);
		}

		if (P3.input.isKeyDown(P3.keys.Y)) {
			this.enableTile(this._world.currentTile);
		}

		if (P3.input.isKeyPressed(P3.keys.X)) {
			this.removeStructure(this._world.currentTile);
		}

		if (P3.input.isKeyDown(P3.keys.R)) {
			this.raiseTile(this._world.currentTile, P3.input.isKeyDown(P3.keys.SHIFT));
		}

		if (P3.input.isKeyDown(P3.keys.F)) {
			this.lowerTile(this._world.currentTile, P3.input.isKeyDown(P3.keys.SHIFT));
		}

		if (P3.input.isKeyPressed(P3.keys.C)) {
			this.copyTile(this._world.currentTile);
		}

		if (P3.input.isKeyPressed(P3.keys.G)) {
			this.hideLevel(!this._isLevelHidden);
			$('input[name=level_hide]').prop('checked', this._isLevelHidden);
		}
		if (P3.input.isKeyPressed(P3.keys.H)) {
			this.hideStructures(!this._isStructuresHidden);
			$('input[name=structures_hide]').prop('checked', this._isStructuresHidden);
		}

		++this._autoSaveFrame % this._autoSaveRate === 0 && this.saveEditor();
	}

	disableTile(tile) {
		if (!tile) {
			return;
		}
		tile.disabled = true;
		tile.setGroundTexture();
	}

	enableTile(tile) {
		if (!tile) {
			return;
		}
		tile.disabled = false;
		tile.setGroundTexture();
	}

	populateSets() {
		const tilesetsArr = [
			{ name: 'Tsunami', value: 'tileset_ts_data' },
			{ name: 'Earthquake', value: 'tileset_eq_data' },
			{ name: 'Flood', value: 'tileset_fd_data' },
			{ name: 'Wildfire', value: 'tileset_wf_data' },
			{ name: 'Hurricane', value: 'tileset_hr_data' },
		];
		const tilesets = $('select[name=select_tileset]');

		for (let i = 0; i < tilesetsArr.length; ++i) {
			const option = tilesetsArr[i];

			tilesets.append(`<option value='${option.value}'>${option.name}</option>`);
		}
		$('select[name=select_tileset]').val(this._tileset);

		const structsetsArr = [
			{ name: 'Tsunami', value: 'structset_ts_data' },
			{ name: 'Earthquake', value: 'structset_eq_data' },
			{ name: 'Flood', value: 'structset_fd_data' },
			{ name: 'Wildfire', value: 'structset_wf_data' },
			{ name: 'Hurricane', value: 'structset_hr_data' },
		];
		const structsets = $('select[name=select_structset]');

		for (let i = 0; i < structsetsArr.length; ++i) {
			const option = structsetsArr[i];

			structsets.append(`<option value='${option.value}'>${option.name}</option>`);
		}
		$('select[name=select_structset]').val(this._structset);

		const upgradesetsArr = [
			{ name: 'Tsunami', value: 'upgradeset_ts_data' },
			{ name: 'Earthquake', value: 'upgradeset_eq_data' },
			{ name: 'Flood', value: 'upgradeset_fd_data' },
			{ name: 'Wildfire', value: 'upgradeset_wf_data' },
			{ name: 'Hurricane', value: 'upgradeset_hr_data' },
		];

		const ind = $('select[name=select_structset]').prop('selectedIndex');

		this._upgradeset = upgradesetsArr[ind].value;
	}

	populateTiles() {
		const tiles = $('#tiles');

		tiles.empty();

		for (const i in this._world.tileset) {
			if (Object.hasOwn(this._world.tileset, i)) {
				const t = this._world.tileset[i];
				const sprite = new PIXI.Sprite(P3.assets.texture(t.images.default));

				tiles.append($(`<li class='${t.id === this._ground ? 'selected' : ''} tile' data-id='${t.id}' data-name='${i}'><img src='${common.renderer.extract.base64(sprite)}' title='${i18next.t(t.description)}'/></li>`));
				sprite.destroy();
			}
		}
		this._bindings.tiles = tiles.on('click', 'li:not(.selected)', (event) => {
			this.onListItemTileClick(event);
		});
	}

	populateStructures() {
		const structures = $('#structures');

		structures.empty();

		for (const i in this._world.structset) {
			if (Object.hasOwn(this._world.structset, i)) {
				const t = this._world.structset[i];
				const sprite = new PIXI.Sprite(P3.assets.texture(t.images.default));

				structures.append($(`<li class='${t.id === this._structure ? 'selected' : ''}' data-id='${t.id}' data-name='${i}'><img src='${common.renderer.extract.base64(sprite)}' title='${i18next.t(t.description)}'/></li>`));
				sprite.destroy();
			}
		}
		this._bindings.structures = structures.on('click', 'li:not(.selected)', (event) => {
			this.onListItemStructureClick(event);
		});
	}

	paintTile(tile, ground, level, ignoreLevel = false, affectNeighbours = false, skipDirty = false) {
		if (!tile) {
			return;
		}
		tile.ground = ground;
		if (!ignoreLevel) {
			tile.level = level;
			this._isLevelHidden && tile.adjustZ(0);
		}
		if (affectNeighbours) {
			for (let i = 0; i < tile.neighbours.length; ++i) {
				this.paintTile(tile.neighbours[i], ground, level, ignoreLevel, false, true);
			}
		}
		!skipDirty && this._world.dirty();
	}

	placeStructure(tile, id) {
		if (!tile) {
			return;
		}
		if (this._isStructuresHidden) {
			alert('You cannot place structures whilst they are hidden!');

			return;
		}
		tile.structure = id;
	}

	removeStructure(tile) {
		if (!tile) {
			return;
		}
		tile.structure = 0;
	}

	raiseTile(tile, affectNeighbours = false, skipDirty = false) {
		if (!tile) {
			return;
		}
		tile.level < 120 && ++tile.level;
		this._isLevelHidden && tile.adjustZ(0);
		if (affectNeighbours) {
			for (let i = 0; i < tile.neighbours.length; ++i) {
				this.raiseTile(tile.neighbours[i], false, true);
			}
		}
		!skipDirty && this._world.dirty();
	}

	lowerTile(tile, affectNeighbours = false, skipDirty = false) {
		if (!tile) {
			return;
		}
		tile.level > -120 && --tile.level;
		this._isLevelHidden && tile.adjustZ(0);
		if (affectNeighbours) {
			for (let i = 0; i < tile.neighbours.length; ++i) {
				this.lowerTile(tile.neighbours[i], false, true);
			}
		}
		!skipDirty && this._world.dirty();
	}

	copyTile(tile) {
		if (!tile) {
			return;
		}
		this._ground = tile.ground;
		this._level = tile.level;
		this._structure = tile.structure > 0 ? tile.structure : this._structure;

		const tiles = $('#tiles');

		tiles.find('li.selected').removeClass('selected');
		tiles.find(`[data-id=${this._ground}]`).addClass('selected');

		const structures = $('#structures');

		structures.find('li.selected').removeClass('selected');
		structures.find(`[data-id=${this._structure}]`).addClass('selected');

		$('input[name=tile_level]').val(this._level);
		$('output[name=tile_level_output]').val(this._level);
	}

	fillMap(id) {
		for (let y = 0, rows = this._world.rows; y < rows; ++y) {
			for (let x = 0, columns = this._world.columns; x < columns; ++x) {
				const tile = this._world.getTile(x, y);

				tile.ground = id;
			}
		}
		this._world.dirty();
	}

	flattenMap(level) {
		for (let y = 0, rows = this._world.rows; y < rows; ++y) {
			for (let x = 0, columns = this._world.columns; x < columns; ++x) {
				const tile = this._world.getTile(x, y);

				tile.level = level;
			}
		}
		this._world.dirty();
	}

	importMap() {
		try {
			const map = JSON.parse($('textarea[name=world_textarea]').val());

			this._world.createMap(map.columns, map.rows, map.tileset, map.structset, map.upgradeset);
			for (let y = 0, rows = this._world.rows; y < rows; ++y) {
				for (let x = 0, columns = this._world.columns; x < columns; ++x) {
					const tile = this._world.getTile(x, y);
					const i = y * this._world.columns + x;

					tile.ground = map.data.ground[i];
					tile.structure = map.data.structure[i];
					tile.level = map.data.level[i];
					if (map.data.disabled && map.data.disabled[i]) {
						this.disableTile(tile);
					}
				}
			}

			$('input[name=world_column]').val(this._world.columns);
			$('output[name=world_column_output]').val(this._world.columns);

			$('input[name=world_row]').val(this._world.rows);
			$('output[name=world_row_output]').val(this._world.rows);

			this._isLevelHidden = this._isStructuresHidden = false;
			$('input[name=level_hide]').prop('checked', false);
			$('input[name=structures_hide]').prop('checked', false);
		} catch (error) {
			console.error(error);
		}
	}

	exportMap() {
		this.saveEditor();

		const editor = common.save.editor;
		const data = {
			columns: editor.map.columns,
			rows: editor.map.rows,
			tileset: editor.map.tileset,
			structset: editor.map.structset,
			upgradeset: editor.map.upgradeset,
			data: {
				ground: editor.map.data.ground.slice(),
				structure: editor.map.data.structure.slice(),
				level: editor.map.data.level.slice(),
				disabled: editor.map.data.disabled.slice(),
			},
		};

		data.hash = editor.map.hash;
		$('textarea[name = world_textarea]').val(JSON.stringify(data));
	}

	shiftMap(x, y = 0) {
		x = Math.round(x);
		y = Math.round(y);
		const rx = Math.sign(x) === 1;
		const ry = Math.sign(y) === 1;

		for (let rows = this._world.rows, j = ry ? rows - 1 : 0; ry ? j >= 0 : j < rows; ry ? --j : ++j) {
			for (let columns = this._world.columns, i = rx ? columns - 1 : 0; rx ? i >= 0 : i < columns; rx ? --i : ++i) {
				const tile = this._world.getTile(i, j);
				const to = this._world.getTile(i + x, j + y * 2);

				if (to && tile !== to) {
					to.ground = tile.ground;
					to.structure = tile.structure;
					to.level = tile.level;
					to.risk = tile.risk;
				}
			}
		}
	}

	hideLevel(value) {
		this._isLevelHidden = value;
		for (let y = 0, rows = this._world.rows; y < rows; ++y) {
			for (let x = 0, columns = this._world.columns; x < columns; ++x) {
				const tile = this._world.getTile(x, y);

				tile.adjustZ(value ? 0 : tile.level);
			}
		}
		this._world.dirty();
	}

	hideRisk(value) {
		this._isRiskHidden = value;
		for (let y = 0, rows = this._world.rows; y < rows; ++y) {
			for (let x = 0, columns = this._world.columns; x < columns; ++x) {
				const tile = this._world.getTile(x, y);

				tile.riskSprite.visible = !value;
			}
		}
	}

	hideStructures(value = true) {
		this._isStructuresHidden = value;
		for (let y = 0, rows = this._world.rows; y < rows; ++y) {
			for (let x = 0, columns = this._world.columns; x < columns; ++x) {
				const tile = this._world.getTile(x, y);

				tile.structureSprite.visible = !value;
			}
		}
	}

	loadMapState(state) {
		this._world.createMap(state.map.columns, state.map.rows, this._tileset, this._structset, this._upgradeset);
		this._world.setCameraPosition((this._world._columns * 86) * 0.5, (this._world._rows * 52) * 0.2 + 54);
		this._world.setCameraZoomLevel(1);

		for (let y = 0, rows = this._world.rows; y < rows; ++y) {
			for (let x = 0, columns = this._world.columns; x < columns; ++x) {
				const tile = this._world.getTile(x, y);
				const i = y * this._world.columns + x;

				state.map.data.ground[i] && (tile.ground = state.map.data.ground[i]);
				state.map.data.disabled[i] && (tile.disabled = state.map.data.disabled[i]);
				state.map.data.structure[i] && (tile.structure = state.map.data.structure[i]);
				state.map.data.level[i] && (tile.level = state.map.data.level[i]);
				state.map.data.risk[i] && (tile.risk = state.map.data.risk[i]);
			}
		}
		this._world.setCameraPosition((this._world._columns * 86) * 0.5, (this._world._rows * 52) * 0.2 + 54);
	}

	loadEditor() {
		common.save.loadEditor();

		const editor = common.save.editor;

		this._ground = editor.settings.ground;
		this._structure = editor.settings.structure;
		this._level = editor.settings.level;
		this._tileset = editor.map.tileset;
		this._structset = editor.map.structset;
		this._upgradeset = editor.map.upgradeset;
		this._autoSaveHash = editor.map.hash;

		this.loadMapState(editor);
	}

	saveEditor() {
		const editor = common.save.editor;

		editor.camera.x = this._world.camera.position.x;
		editor.camera.y = this._world.camera.position.y;
		editor.camera.level = this._world.cameraZoomLevel;

		editor.settings.ground = this._ground;
		editor.settings.structure = this._structure;
		editor.settings.level = this._level;

		editor.map.columns = this._world.columns;
		editor.map.rows = this._world.rows;
		editor.map.tileset = this._tileset;
		editor.map.structset = this._structset;
		editor.map.upgradeset = this._upgradeset;
		editor.map.data.ground = [];
		editor.map.data.structure = [];
		editor.map.data.level = [];
		editor.map.data.disabled = [];

		for (let y = 0, rows = this._world.rows; y < rows; ++y) {
			for (let x = 0, columns = this._world.columns; x < columns; ++x) {
				const tile = this._world.getTile(x, y);

				editor.map.data.ground.push(tile.ground);
				editor.map.data.structure.push(tile.structure);
				editor.map.data.level.push(tile.level);
				editor.map.data.disabled.push(tile.disabled);
			}
		}

		delete editor.map.hash;
		editor.map.hash = P3.utils.md5(JSON.stringify(editor.map));
		common.save.saveEditor();
	}

	onNewButtonClick() {
		if (confirm('WARNING: You are about to create a new world. This is not undoable!')) {
			const columns = parseInt($('input[name=world_column]').val());
			const rows = parseInt($('input[name=world_row]').val());

			this._world.createMap(columns, rows, this._tileset, this._structset, this._upgradeset);
			this.saveEditor();
		}
	}

	onResizeButtonClick() {
		if (confirm('WARNING: You are about to resize the world. This is not undoable!')) {
			const columns = parseInt($('input[name=world_column]').val());
			const rows = parseInt($('input[name=world_row]').val());

			this._world.resizeMap(columns, rows, this._tileset, this._structset);
			this.saveEditor();
		}
	}

	onFillButtonClick() {
		if (confirm('WARNING: You are about to fill the world. This is not undoable!')) {
			this.fillMap(this._ground);
			this.saveEditor();
		}
	}

	onFlattenButtonClick() {
		if (confirm('WARNING: You are about to flatten the world. This is not undoable!')) {
			this.flattenMap(this._level);
			this.saveEditor();
		}
	}

	onShiftButtonClick() {
		if (confirm('WARNING: You are about to shift the world. This is not undoable!')) {
			const x = parseInt($('input[name=shift_column]').val());
			const y = parseInt($('input[name=shift_row]').val());

			this.shiftMap(x, y);

			parseInt($('input[name=shift_column]').val(0));
			$('output[name=shift_column_output]').val(0);

			parseInt($('input[name=shift_row]').val(0));
			$('output[name=shift_row_output]').val(0);
		}
	}

	onImportButtonClick() {
		this.importMap();
		this.saveEditor();
	}

	onExportButtonClick() {
		this.exportMap();
		this.saveEditor();
	}

	onTilesetSelect() {
		this._tileset = $('select[name=select_tileset]').val();
		this._world.parseSets(this._tileset, this._structset, this._upgradeset);

		let i;

		for (i in this._world.tileset) {
			break;
		}
		this._ground = this._world.tileset[i].id;

		this.populateTiles();

		this.saveEditor();

		const editor = common.save.editor;

		this.loadMapState(editor);
	}

	onStructsetSelect() {
		this._structset = $('select[name=select_structset]').val();
		this._world.parseSets(this._tileset, this._structset, this._upgradeset);

		let i;

		for (i in this._world.structset) {
			break;
		}
		this._structure = this._world.structset[i].id;

		this.populateStructures();

		this.saveEditor();

		const editor = common.save.editor;

		this.loadMapState(editor);
	}

	onLevelHide() {
		const checkbox = $('input[name=level_hide]');

		this.hideLevel(checkbox.prop('checked'));
	}

	onRiskHide() {
		const checkbox = $('input[name=risk_hide]');

		this.hideRisk(checkbox.prop('checked'));
	}

	onStructuresHide() {
		const checkbox = $('input[name=structures_hide]');

		this.hideStructures(checkbox.prop('checked'));
	}

	onListItemTileClick(event) {
		$('#tiles').find('li.selected').removeClass('selected');

		const t = $(event.currentTarget);

		t.addClass('selected');

		const data = this._world.getGroundByName(t.attr('data-name'));

		data && (this._ground = data.id);
	}

	onListItemStructureClick(event) {
		$('#structures').find('li.selected').removeClass('selected');

		let t = $(event.currentTarget);

		if (!t.prev().is('li')) {
			t = t.closest('li');
		}

		t.addClass('selected');

		const data = this._world.getStructureByName(t.attr('data-name'));

		if (data) {
			this._structure = data.id;
		}
	}

	onInputTileLevelChange(event) {
		this._level = parseInt($(event.currentTarget).val());
	}

	onWorldTilePaint(world, tile) {
		this.paintTile(tile, this._ground, this._level, P3.input.isKeyDown(P3.keys.CTRL), P3.input.isKeyDown(P3.keys.SHIFT));
	}
}
